import { required } from '@ps/web-shared-components';
import React from 'react';
import { Field } from 'react-final-form';

import useValidator from '@swf/core/hooks/useValidator';
import useWizardContext from '@swf/core/hooks/useWizardContext';

import { CashierFlowType } from '../../../../../../types/Cashier';
import Checkbox from '../../../../../Checkbox/Checkbox';

import {
  TXTWCL_I_confirm_that_I_am_the_regist_ELL,
  TXTWCL_I_confirm_that_I_am_the_regist_ELL_1
} from './ConfirmationCheckbox.messages.json';
import { container } from './ConfirmationCheckbox.scss';

export const fieldName = 'ownershipConfirmation';

const ConfirmationCheckbox: React.FC = () => {
  const [validator] = useValidator(required());
  const {
    data: { cashierFlow, unverifiedOptions = [] }
  } = useWizardContext();

  const isSingleUnverifiedMethod =
    cashierFlow === CashierFlowType.FirstDeposit || unverifiedOptions.length === 1;

  return (
    <div className={container}>
      <Field name={fieldName} type="checkbox" validate={validator}>
        {({ input: { onChange, checked }, meta }) => (
          <Checkbox
            meta={meta}
            name={fieldName}
            checked={checked}
            onChange={onChange}
            label={
              isSingleUnverifiedMethod
                ? TXTWCL_I_confirm_that_I_am_the_regist_ELL
                : TXTWCL_I_confirm_that_I_am_the_regist_ELL_1
            }
          />
        )}
      </Field>
    </div>
  );
};

export default ConfirmationCheckbox;
